import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../../shared/my-constants';

// import * as webapi from '../../assets/js/webproperty.js';
@Injectable()
export class OpdAppoinmentService {
    city: any;
    private headers = new Headers({'Content-Type': 'application/json'});
 //   private GetAppointmentList = webapi + 'mis/appointmentlist';
    private GetAppointmentList = webapi + 'mis/getlistofAppointmentReport';

    constructor(private http: Http) {
    }

    getListofAppointmentReport(model: any, unitList: any, fromdate: any, todate: any) {
        return this.http.post(this.GetAppointmentList + '/' + unitList + '/' + fromdate + '/' + todate, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mis/mis-opd/opd-appointment/opd-appointment.service.ts